import Field from '@/components/common/Field/Field';
import * as S from './style';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { ContainerInput } from '@/components/common/Input/InputText/style';
import { useSignUpStore } from '../SignUpContext/SignUpContext';
import { SignupDataType, usePostSignupApi } from '@/api/auth';
import { useEffect } from 'react';
interface RegisterField {
	topic: string;
	spot: string;
}
const EtcInfoForm = () => {
	const { setStep, updateEtcInfo, getInfo, etcInfo, setCurrentStep } = useSignUpStore();
	const { mutateAsync: Signup } = usePostSignupApi();
	const userRegisterSchema = z.object({
		topic: z.string(),
		spot: z.string().min(1, '이름을 입력해 주세요'),
	});

	const { register, handleSubmit, setValue } = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		defaultValues: { topic: '', spot: '자택' }, // 초기값을 배열로 설정
	});

	const onSubmit = async (data: RegisterField) => {
		updateEtcInfo(data);
		const allData = getInfo();

		const params: SignupDataType = {
			member_name: allData.basicInfo.name,
			member_en_name: allData.basicInfo.enName,
			member_birth_year: allData.basicInfo.birth.year,
			member_birth_month: allData.basicInfo.birth.month,
			member_birth_date: allData.basicInfo.birth.day,
			member_gender: allData.basicInfo.gender,
			member_cell: allData.basicInfo.cell.replace(/-/g, ''),
			member_id: allData.basicInfo.id,
			member_password: allData.basicInfo.password,
			member_re_password: allData.basicInfo.passwordCheck,
			member_zipcode: allData.basicInfo.address.zipcode,
			member_address: allData.basicInfo.address.address,
			member_address_detail: allData.basicInfo.address.detailAddress,
			member_email: `${allData.basicInfo.email.front}@${allData.basicInfo.email.back}`,
			member_company_name: allData.companyInfo.company_name ?? '',
			member_company_en_name: allData.companyInfo.company_name_en ?? '',
			member_position: allData.companyInfo.position ?? '',
			member_md: allData.companyInfo.md ?? '',
			member_company_tel: allData.companyInfo.phone ?? '',
			member_company_fax: allData.companyInfo.fax ?? '',
			member_company_zipcode: allData.companyInfo.zipcode ?? '',
			member_company_address: allData.companyInfo.address ?? '',
			member_company_address_detail: allData.companyInfo.detailAddress ?? '',
			member_edu: allData.educationInfo.map((edu) => `${edu.school}♩${edu.degree}♩${edu.major}♩${edu.year}♩${edu.country}`).join('♫'),
			member_research_topic: data.topic,
			member_receive_post: data.spot,
		};

		try {
			const res = await Signup(params);
			if (res.data.success) {
				setStep('회원가입 완료');
				setCurrentStep('회원가입 완료');
			}
		} catch (error) {
			console.error('❌ Signup API 요청 실패:', error);
			// 에러 핸들링
		}
	};
	useEffect(() => {
		const hasInfo = etcInfo.topic || etcInfo.recommender || etcInfo.spot;

		if (hasInfo) {
			setValue('topic', etcInfo.topic ?? '');
			setValue('spot', etcInfo.spot);
		}
	}, [etcInfo]);
	return (
		<S.FormContainer>
			<S.Container>
				<S.FormBox>
					<S.Danger>*필수 입력 값</S.Danger>
					<Field title="연구주제(관심분야)">
						<ContainerInput {...register('topic')} />
					</Field>

					<Field title="*우편물 수령 장소 선택" gap="0.8rem">
						<S.SpotExplain>※ 한국노화학회에서 보내는 우편물(학회지 및 논문집)을 선택하신 곳으로 받아 보실 수 있습니다.</S.SpotExplain>

						<S.GenderBox>
							<S.GenderRadio>
								<label>
									<input type="radio" value="자택" {...register('spot')} />
									자택
								</label>
							</S.GenderRadio>
							<S.GenderRadio>
								<label>
									<input type="radio" value="직장" {...register('spot')} />
									직장
								</label>
							</S.GenderRadio>
						</S.GenderBox>
					</Field>
				</S.FormBox>
				<S.NextButton type="button" onClick={handleSubmit(onSubmit)}>
					정보 입력 완료
				</S.NextButton>
			</S.Container>
		</S.FormContainer>
	);
};
export default EtcInfoForm;
